import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDebounce, useNotification, useUser } from '../../hooks';
import LoginForm from '../forms/login';

const Login = () => {
  const notification = useNotification();
  const { state } = useLocation();
  const history = useHistory();
  const [disabled, setDisabled] = useState(false);
  const { isUserLoggedIn, error, login, loginGoogle } = useUser();

  useEffect(() => {
    if (isUserLoggedIn) {
      notification.success({ message: 'You was successfully logged in' });
      history.push(state && state.from ? state.from : '/candidates');
    }
  }, [isUserLoggedIn]);

  useEffect(() => {
    if (error) {
      notification.error(error);
      setDisabled(false);
    }
  }, [error]);

  const handleSubmit = useDebounce((credentials) => {
    setDisabled(true);
    login(credentials);
  }, 1000);

  return <LoginForm disabled={disabled} onSubmit={handleSubmit} loginGoogle={loginGoogle} />;
};

export default Login;
